import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for fetching duty records
export const fetchDutyRecords = createAsyncThunk(
  'dutyRecords/fetchDutyRecords',
  async ({ lessonId, page = 1 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      
      if (!token) {
        throw new Error('No token found');
      }


      
      const response = await axios.get(`${BASE_URL}/duties/lesson_students_entered/${lessonId}?page=${page}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = response.data;

      if (data.status === 'success') {
        return {
          students: data.result.data,
          pagination: data.result.pagination
        };
      } else {
        return rejectWithValue(data.message || 'حدث خطأ في تحميل سجل الواجبات');
      }
    } catch (error) {
      console.error('Error fetching duty records:', error);
      return rejectWithValue(error.message || 'حدث خطأ في تحميل سجل الواجبات');
    }
  }
);

const initialState = {
  students: [],
  pagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    pages_count: 0
  },
  loading: false,
  error: null,
  currentPage: 1
};

const dutyRecordsSlice = createSlice({
  name: 'dutyRecords',
  initialState,
  reducers: {
    clearDutyRecords: (state) => {
      state.students = [];
      state.pagination = {
        total: 0,
        per_page: 10,
        current_page: 1,
        pages_count: 0
      };
      state.error = null;
    },
    clearDutyRecordsError: (state) => {
      state.error = null;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDutyRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDutyRecords.fulfilled, (state, action) => {
        state.loading = false;
        state.students = action.payload.students;
        state.pagination = action.payload.pagination;
        state.error = null;
      })
      .addCase(fetchDutyRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearDutyRecords, clearDutyRecordsError, setCurrentPage } = dutyRecordsSlice.actions;
export default dutyRecordsSlice.reducer;
